import type {
  ComponentValueResponse,
  EninCompanySearchResponse,
  EninLookupInput,
  SaveComponentValueResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getFlowInstanceValue(instanceId: string) {
  return get<ComponentValueResponse>(`${BASE}/${instanceId}/enin-lookup/flow-instance-value`);
}

export function searchAndSave(instanceId: string, input: EninLookupInput) {
  return post<SaveComponentValueResponse>(
    `${BASE}/${instanceId}/enin-lookup/flow-instance-value`,
    input,
  );
}

export function screenPersons(instanceId: string) {
  return post<SaveComponentValueResponse>(`${BASE}/${instanceId}/enin-lookup/screen-persons`, {});
}

export function searchCompanies(instanceId: string, name: string, limit = 10) {
  return get<EninCompanySearchResponse>(
    `${BASE}/${instanceId}/enin-lookup/company-search?name=${encodeURIComponent(name)}&limit=${limit}`,
  );
}
